<div class="role-drop-container">
  <ng-container *ngIf="studentRoleSettings">
    <div class="p-0">
      <div class="role d-flex">
        <div class="select-role-header flex-grow-1">
          <p>{{ 'switch_roles' | label : 'rolesoverview' | async }}</p>
        </div>
        <div *ngIf="countroles > 1" class="standard-header">
          <p>{{ 'standard' | label : 'rolesoverview' | async }}</p>
        </div>
      </div>
    </div>
    <div class="dropdown-item p-0 pe-2" *ngIf="studentRoleSettings.studentId">
      <div class="role d-flex">
        <a class="pb-4 pt-4" style="width: 71px" (click)="changeToEmployee()">
          <div class="ps-4 pe-4">
            <div class="profilePicture" style="border: 1px solid var(--progreso-accent); background-color: var(--progreso-accent)"></div>
          </div>
        </a>

        <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToEmployee()">
          <div class="roleDescription">
            <h1 class="pb-0 text-truncate">
              {{ 'employee' | label : 'roleswitch' | async }}
              <ng-container *ngIf="studentRoleSettings.coupledEmployees && studentRoleSettings.coupledEmployees.length && currentStudent"> ({{ currentStudent.function }}, {{ currentStudent.department }}) </ng-container>
            </h1>
          </div>
        </a>

        <div *ngIf="countroles > 1" class="default-role" [ngbTooltip]="'choosedefaultrole' | label : 'roleswitch' | async">
          <input type="radio" name="{{ name }}" [value]="levels.Employee" [(ngModel)]="defaultLevel" (ngModelChange)="changeDefaultRole($event)" />
        </div>
      </div>
    </div>
    <ng-container *ngIf="studentRoleSettings.coupledEmployees && studentRoleSettings.coupledEmployees.length">
      <ng-container *ngFor="let coupledEmployee of studentRoleSettings.coupledEmployees">
        <div class="dropdown-item p-0 pe-2">
          <div class="role d-flex">
            <a class="pb-4 pt-4" style="width: 71px" (click)="changeToCoupledEmployee(coupledEmployee)">
              <div class="ps-4 pe-4">
                <div class="profilePicture" style="border: 1px solid var(--progreso-accent); background-color: var(--progreso-accent)"></div>
              </div>
            </a>

            <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToCoupledEmployee(coupledEmployee)">
              <div class="roleDescription">
                <h1 class="pb-0 text-truncate">
                  {{ 'coupledEmployee' | label : 'roleswitch' | async }}
                  {{ 'employee' | label : 'roleswitch' | async }}
                  ({{ coupledEmployee.functionName }}, {{ coupledEmployee.departmentName }})
                </h1>
              </div>
            </a>

            <div class="default-role"></div>
          </div>
        </div>
        <div *ngIf="coupledEmployee.isManager" class="dropdown-item p-0 pe-2">
          <div class="role d-flex">
            <a class="pb-4 pt-4" style="width: 71px" (click)="changeToCoupledEmployee(coupledEmployee, true)">
              <div class="ps-4 pe-4">
                <div class="profilePicture" style="border: 1px solid var(--progreso-accent); background-color: var(--progreso-accent)"></div>
              </div>
            </a>

            <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToCoupledEmployee(coupledEmployee, true)">
              <div class="roleDescription">
                <h1 class="pb-0 text-truncate">
                  {{ 'coupledEmployee' | label : 'roleswitch' | async }}
                  {{ 'teamleader' | label : 'roleswitch' | async }}
                  ({{ coupledEmployee.functionName }}, {{ coupledEmployee.departmentName }})
                </h1>
              </div>
            </a>

            <div class="default-role"></div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="dropdown-item p-0 pe-2" *ngIf="studentRoleSettings.isManager">
      <div class="role d-flex">
        <a class="pb-4 pt-4" style="width: 71px" (click)="changeToManager()">
          <div class="ps-4 pe-4">
            <div class="profilePicture" style="border: 1px solid var(--progreso-accent-hover); background-color: var(--progreso-accent-hover)"></div>
          </div>
        </a>
        <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToManager()">
          <div class="roleDescription">
            <h1 class="pb-0 text-truncate">{{ 'teamleader' | label : 'roleswitch' | async }}</h1>
          </div>
        </a>

        <div *ngIf="countroles > 1" class="default-role" [ngbTooltip]="'choosedefaultrole' | label : 'roleswitch' | async">
          <input type="radio" name="{{ name }}" [value]="levels.Manager" [(ngModel)]="defaultLevel" (ngModelChange)="changeDefaultRole($event)" />
        </div>
      </div>
    </div>

    <ng-container *ngIf="studentRoleSettings.delegatedTeams">
      <ng-container *ngIf="studentRoleSettings.delegatedTeams.length">
        <div class="dropdown-item p-0 pe-2" *ngFor="let team of studentRoleSettings.delegatedTeams">
          <div class="role d-flex">
            <a class="pb-4 pt-4" style="width: 71px" (click)="changeToDelegate(team)">
              <div class="ps-4 pe-4">
                <div class="profilePicture" style="border: 1px solid var(--progreso-accent-hover); background-color: var(--progreso-accent-hover)"></div>
              </div>
            </a>

            <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToDelegate(team)">
              <div class="roleDescription">
                <h1 class="pb-0 text-truncate">
                  {{ 'teamleader' | label : 'roleswitch' | async }} -
                  {{ team.teamName }}
                </h1>
              </div>
            </a>
            <div class="default-role"></div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="dropdown-item p-0 pe-2" *ngIf="studentRoleSettings.isMatrixManager && !studentRoleSettings.isManager">
      <div class="role d-flex">
        <a class="pb-4 pt-4" style="width: 71px" (click)="changeToMatrixManager()">
          <div class="ps-4 pe-4">
            <div class="profilePicture" style="border: 1px solid var(--progreso-accent-hover); background-color: var(--progreso-accent-hover)"></div>
          </div>
        </a>

        <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToMatrixManager()">
          <div class="roleDescription flex-grow-1 align-self-center">
            <h1 class="pb-0 text-truncate">
              {{ 'matrix_manager' | label : 'roleswitch' | async }}
            </h1>
          </div>
        </a>

        <div *ngIf="countroles > 1" class="default-role" [ngbTooltip]="'choosedefaultrole' | label : 'roleswitch' | async">
          <input type="radio" name="{{ name }}" [value]="levels.MatrixManager" [(ngModel)]="defaultLevel" (ngModelChange)="changeDefaultRole($event)" />
        </div>
      </div>
    </div>

    <div class="dropdown-item p-0 pe-2" *ngIf="studentRoleSettings.trainerId">
      <div class="role d-flex">
        <a class="pb-4 pt-4" style="width: 71px" (click)="changeToTrainer()">
          <div class="ps-4 pe-4">
            <div class="profilePicture" style="border: 1px solid var(--progreso-primary); background-color: var(--progreso-primary)"></div>
          </div>
        </a>

        <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToTrainer()">
          <div class="roleDescription">
            <h1 class="pb-0 text-truncate">
              {{ 'trainer' | label : 'roleswitch' | async }}
            </h1>
          </div>
        </a>

        <div *ngIf="countroles > 1" class="default-role" [ngbTooltip]="'choosedefaultrole' | label : 'roleswitch' | async">
          <input type="radio" name="{{ name }}" [value]="levels.Trainer" [(ngModel)]="defaultLevel" (ngModelChange)="changeDefaultRole($event)" />
        </div>
      </div>
    </div>

    <div class="dropdown-item p-0 pe-2" *ngIf="studentRoleSettings.localHrId">
      <div class="role d-flex">
        <a class="pb-4 pt-4" style="width: 71px" (click)="changeToLocalHr()">
          <div class="ps-4 pe-4">
            <div class="profilePicture" style="border: 1px solid var(--progreso-secondary); background-color: var(--progreso-secondary)"></div>
          </div>
        </a>

        <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToLocalHr()">
          <div class="roleDescription">
            <h1 class="pb-0 text-truncate">
              {{ 'localhr' | label : 'roleswitch' | async }}
            </h1>
          </div>
        </a>

        <div *ngIf="countroles > 1" class="default-role" [ngbTooltip]="'choosedefaultrole' | label : 'roleswitch' | async">
          <input type="radio" name="{{ name }}" [value]="levels.LocalHr" [(ngModel)]="defaultLevel" (ngModelChange)="changeDefaultRole($event)" />
        </div>
      </div>
    </div>

    <div class="dropdown-item p-0 pe-2" *ngIf="studentRoleSettings.corporateHrId">
      <div class="role d-flex">
        <a class="pb-4 pt-4" style="width: 71px" (click)="changeToCorporateHr()">
          <div class="ps-4 pe-4">
            <div class="profilePicture" style="border: 1px solid var(--progreso-secondary); background-color: var(--progreso-secondary)"></div>
          </div>
        </a>

        <a class="pb-4 pt-4 flex-grow-1 align-self-center" style="max-width: 82%" (click)="changeToCorporateHr()">
          <div class="roleDescription">
            <h1 class="pb-0 text-truncate">
              {{ 'corporatehr' | label : 'roleswitch' | async }}
            </h1>
          </div>
        </a>

        <div *ngIf="countroles > 1" class="default-role" [ngbTooltip]="'choosedefaultrole' | label : 'roleswitch' | async">
          <input type="radio" name="{{ name }}" [value]="levels.CorporateHr" [(ngModel)]="defaultLevel" (ngModelChange)="changeDefaultRole($event)" />
        </div>
      </div>
    </div>
  </ng-container>

  <a class="dropdown-item p-3 logoff" style="min-width: 275px" (click)="logOff()" *ngIf="logoffLabel$ | async as logoffLabel">
    {{ logoffLabel.labelText }}
  </a>
</div>
